import _ from "lodash";
import { dispatch, get } from "vuex-pathify";

export default {
    created() {
        dispatch("configure/getVehicleStyle", this.styleId);

        const configurationState = _.get(
            this.$route,
            "query.configuration_state"
        );
        if (!_.isNil(configurationState)) {
            dispatch("configure/setConfigurationState", {
                configurationState,
                styleId: this.styleId
            });
        } else {
            dispatch("configure/getOptions", this.styleId);
        }

        const certificateId = _.get(this.$route, "query.cid");
        if (!_.isNil(certificateId)) {
            this.certificateId = certificateId;
        }
    },

    computed: {
        vehicleName: get("configure/vehicleName"),
        vehicleDetailsUrl: get("configure/vehicleDetailsUrl")
    }
};
